import { trigger, transition, group, query, animate, style } from '@angular/animations';
import { Subscription } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Component, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { combineLatest } from 'rxjs';
import { WebSiteUsersService } from '@app/services/webSiteUsers/webSiteUsers.service';
import { AddAddressComponent } from '@app/modules/modals/add-address/add-address.component';
import { OrdersService } from '@app/services/order/orders.service';

@Component({
    moduleId: module.id,
    selector: 'profil',
    templateUrl: 'profil.component.html',
    styleUrls: ['profil.component.scss'],
    animations: [
        trigger('fade', [
            transition('* <=> *', [
                group([
                    query('#profile', [
                        style({ opacity: 0, transform: 'translate(0,-100%)' }),
                    ], { optional: true }),

                    query('#my-address', [
                        style({ opacity: 0, transform: 'translate(0,-100%)' }),
                    ], { optional: true }),

                    query('#change-password', [
                        style({ opacity: 0, transform: 'translate(0,-100%)' }),
                    ], { optional: true })
                ]),
                query('#profile', [
                    animate('300ms ease-in', style({ opacity: 1, transform: 'translate(0,0)' }))
                ], { optional: true }),

                query('#my-address', [
                    animate('300ms ease-in', style({ opacity: 1, transform: 'translate(0,0)' }))
                ], { optional: true, delay: 100 }),

                query('#change-password', [
                    animate('300ms ease-in', style({ opacity: 1, transform: 'translate(0,0)' }))
                ], { optional: true, delay: 100 })
            ])
        ])
    ]
})
export class ProfilComponent {
    customer: any = {
        lastname: "",
        firstname: "",
        email: "",
        phone: "",
        password: "",
        oldPassword: "",
        confirmePassword: ""
    };
    oldPassword: any = '';
    address: any[];
    updateInfo: boolean = false;
    token: any;
    modalRef: BsModalRef;
    subscriptions: Subscription[] = [];
    j;
    ourApp = false;
    constructor(private webSiteUsersService: WebSiteUsersService,
        private toastr: ToastrService,
        private modalService: BsModalService,
        private changeDetection: ChangeDetectorRef,
        private orderService : OrdersService
    ) {
        this.getInfo();
        this.orderService.ourAppEvent.subscribe(
            data => {
                this.ourApp = data;
            }
        )

    }

    getInfo() {
        this.webSiteUsersService.getInfo().subscribe(
            (data: any) => {
                this.customer.lastname = data[0].lastname;
                this.customer.firstname = data[0].firstname;
                this.customer.email = data[0].email;
                this.customer.phone = data[0].phone;
                this.getAddress();
            }
        )
    }
    updateUser() {
        if (!this.customer.firstname || !this.customer.lastname) {
            this.toastr.error('Merci de remplir tous les champs', 'Attention !');
        } else {
            if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.customer.email))) {
                this.toastr.error('Merci de saisir une adresse email valide', 'Attention !');
            } else {
                if (this.customer.phone.trim() == '' || !this.customer.phone.match(/^\d{10}$/)) {
                    this.toastr.error('Merci de saisir un numèro valide', 'Attention !');
                } else {
                    if (this.customer.oldPassword.trim() == '') {
                        this.toastr.error('Merci de saisir votre mot de passe', 'Attention !');
                    } else {
                        this.webSiteUsersService.updateUser(this.customer).subscribe(
                            (data: any) => {
                                if (data.code == 200) {
                                    this.updateInfo = false;
                                    this.toastr.success('Votre compte a été modifié', 'Modification');
                                }
                            }, (err: any) => {
                                if (err.status == 400) {
                                    this.toastr.error('Votre mot de passe est incorrect', 'Attention !');
                                }
                            }
                        )
                    }
                }
            }
        }
    }
    updatePassword() {
        if (this.oldPassword == '' || this.oldPassword.length < 8) {
            this.toastr.error('Le mot de passe actuel est invalide (minimum 8 caractères)', 'Attention !');
        }
        else {
            if (this.customer.password.trim() == '' || this.oldPassword.length < 8) {
                this.toastr.error('Le nouveau mot de passe est invalide (minimum 8 caractères)', 'Attention !');
            } else {
                if (this.customer.confirmePassword.trim() == '' || this.oldPassword.length < 8) {
                    this.toastr.error('Le nouveau mot de passe est invalide (minimum 8 caractères)', 'Attention !');
                } else {
                    if (this.customer.confirmePassword != this.customer.password) {
                        this.toastr.error('les deux mot de passe ne sont pas identiques', 'Attention !');
                    } else {
                        this.webSiteUsersService.updatePassword({ password: this.customer.password, oldPassword: this.oldPassword }).subscribe(
                            (data: any) => {
                                this.updateInfo = false;
                                this.customer.password = '';
                                this.customer.confirmePassword = '';
                                this.oldPassword = '';
                                this.toastr.success('Votre mot de passe a été modifié', 'Modification');
                            }, (err: any) => {
                                if (err.status == 400) {
                                    this.toastr.error('Votre mot de passe est incorrect', 'Attention !');
                                }
                            }
                        )
                    }
                }
            }
        }

    }
    addAddress() {
        const _combine = combineLatest(
            this.modalService.onHidden
        ).subscribe(() => this.changeDetection.markForCheck());
        this.subscriptions.push(
            this.modalService.onHidden.subscribe((address: any) => {
                if (address && address.id) {
                    let index = this.address.findIndex(a => a.id == address.id);
                    if (index == -1) {
                        this.address.unshift(address);
                    }
                }
                this.unsubscribe();
            })
        );
        this.modalRef = this.modalService.show(AddAddressComponent, { class: 'modal-content-address' });

    }
    getAddress() {
        this.webSiteUsersService.getAddress().subscribe(
            (data: any) => {
                this.address = data;
            }
        )
    }
    editAddress(i) {
        this.modalRef = this.modalService.show(AddAddressComponent, { class: 'modal-content-address' });
        this.modalRef.content.address = this.address[i];
    }
    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }
    deleteAddress(i) {
        this.webSiteUsersService.deleteAddress(this.address[i].id).subscribe(
            (data: any) => {
                this.address.splice(i, 1);
                this.modalRef.hide();
            }
        )
    }

    openModal(template: TemplateRef<any>, i) {
        this.modalRef = this.modalService.show(template, { class: 'ordertype-modal' });
        this.j = i;
    }

    confirm(): void {
        this.deleteAddress(this.j);
    }

    decline(): void {
        this.modalRef.hide();
    }
}
